import { useEffect, type FC } from "react";
import styled from "styled-components";
import Alert from "./Alert";

interface Props {
  title: string;
  message?: string;
  type?: "error" | "success" | "warning" | "info" | "issue";
  onClose: () => void;
  duration?: number;
}

const ToastContainer = styled.div`
  position: fixed;
  top: 80px;
  right: 24px;
  z-index: 1000;
  max-width: 480px;
`;

const Toast: FC<Props> = ({
  title,
  message,
  type = "success",
  onClose,
  duration = 4000,
}) => {
  useEffect(() => {
    const timeout = setTimeout(onClose, duration);
    return () => clearTimeout(timeout);
  }, [onClose, duration]);

  return (
    <ToastContainer>
      <Alert type={type} title={title} message={message} onClickClose={onClose} />
    </ToastContainer>
  );
};

export default Toast;
